import { $ } from "@/common/Axios";

export default {
  /**
   * 职教谈话
   */
  talk: {
    /*
     * 修改
     * talk  ( query required)
     */
    put: (p, c) => $.put("/api/zms/archive/talk", p, c),

    /*
     * 添加
     * talk  ( query required)
     */
    post: (p, c) => $.post("/api/zms/archive/talk", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/talk", p, c),
  },
  talk_restore: {
    /*
     * 修复联系记录
     */
    put: (p, c) => $.put("/api/zms/archive/talk/restore", p, c),
  },
  talk_listByTypeAndSchoolRollId: {
    /*
     * 根据类型和合同id查询
     * type 类型：重点学生跟进、日常跟进、家长跟进 (string query required)
     * contentType 内容类型：聊天记录、截图录音 (string query required)
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/zms/archive/talk/listByTypeAndSchoolRollId", p, c),
  },
  talk_finishParentInfo: {
    /*
     * 获取当月未联系家长数量
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     */
    get: (p, c) => $.get("/api/zms/archive/talk/finishParentInfo", p, c),
  },
  talk_finishInfo: {
    /*
     * 获取非重点学生每月联系情况
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     */
    get: (p, c) => $.get("/api/zms/archive/talk/finishInfo", p, c),
  },
  talk_exportVipTalk: {
    /*
     * 重点跟进记录导出
     * siteId 学校id (integer query )
     * classRoomId 班级id (integer query )
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     */
    get: (p, c) => $.get("/api/zms/archive/talk/exportVipTalk", p, c),
  },
  talk_countVipUnfinish: {
    /*
     * 统计重点学生每周谈话未完成人数
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     */
    get: (p, c) => $.get("/api/zms/archive/talk/countVipUnfinish", p, c),
  },

  /**
   * 班团干部
   */
  classCadre_setPosition: {
    /*
     * 设置职位
     * type 类型 (string query required)
     * positions 职位 (array query required)
     */
    put: (p, c) => $.put("/api/zms/archive/classCadre/setPosition", p, c),
  },
  classCadre: {
    /*
     * 添加
     * cadre  ( query required)
     */
    post: (p, c) => $.post("/api/zms/archive/classCadre", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/classCadre", p, c),
  },
  classCadre_upload: {
    /*
     * 导入
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/zms/archive/classCadre/upload", p, c),
  },
  classCadre_uploadForCont: {
    /*
     * 导入(职教学校平台)
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/zms/archive/classCadre/uploadForCont", p, c),
  },
  classCadre_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/classCadre/list", p, c),
  },
  classCadre_listSimpleByStudent: {
    /*
     * 根据学生获取职位列表
     * classRoomId 班级id (integer query required)
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/zms/archive/classCadre/listSimpleByStudent", p, c),
  },
  classCadre_listPosition: {
    /*
     * 获取职位
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/zms/archive/classCadre/listPosition", p, c),
  },
  classCadre_listForCont: {
    /*
     * 列表(职教学校平台domain)
     */
    get: (p, c) => $.get("/api/zms/archive/classCadre/listForCont", p, c),
  },
  classCadre_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/classCadre/export", p, c),
  },
  classCadre_exportForCont: {
    /*
     * 导出(职教学校平台)
     */
    get: (p, c) => $.get("/api/zms/archive/classCadre/exportForCont", p, c),
  },

  /**
   * 档案周完成情况
   */
  archiveWeekFinishInfo_refresh: {
    /*
     * 单个刷新
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/zms/archive/archiveWeekFinishInfo/refresh", p, c),
  },
  archiveWeekFinishInfo_batchRefresh: {
    /*
     * 批量刷新
     * startTime 开始时间 (string query required)
     */
    put: (p, c) =>
      $.put("/api/zms/archive/archiveWeekFinishInfo/batchRefresh", p, c),
  },
  archiveWeekFinishInfo_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/archiveWeekFinishInfo/list", p, c),
  },
  archiveWeekFinishInfo_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/archiveWeekFinishInfo/export", p, c),
  },

  /**
   * 档案月完成情况
   */
  archiveMonthFinishInfo_refresh: {
    /*
     * 单个刷新
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/zms/archive/archiveMonthFinishInfo/refresh", p, c),
  },
  archiveMonthFinishInfo_batchRefresh: {
    /*
     * 批量刷新
     * startTime 开始时间 (string query required)
     */
    put: (p, c) =>
      $.put("/api/zms/archive/archiveMonthFinishInfo/batchRefresh", p, c),
  },
  archiveMonthFinishInfo_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/archiveMonthFinishInfo/list", p, c),
  },
  archiveMonthFinishInfo_listYear: {
    /*
     * 年份列表
     */
    get: (p, c) =>
      $.get("/api/zms/archive/archiveMonthFinishInfo/listYear", p, c),
  },
  archiveMonthFinishInfo_listMonth: {
    /*
     * 月份列表
     * year 年 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/archive/archiveMonthFinishInfo/listMonth", p, c),
  },
  archiveMonthFinishInfo_finishInfo: {
    /*
     * 完成情况
     * year 年 (string query required)
     * month 月 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/archive/archiveMonthFinishInfo/finishInfo", p, c),
  },
  archiveMonthFinishInfo_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/zms/archive/archiveMonthFinishInfo/export", p, c),
  },

  /**
   * 工作计划
   */
  workPlan: {
    /*
     * 添加
     * plan  ( query required)
     */
    post: (p, c) => $.post("/api/zms/archive/workPlan", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/workPlan", p, c),
  },
  workPlan_upload: {
    /*
     * 导入
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/zms/archive/workPlan/upload", p, c),
  },
  workPlan_uploadForCont: {
    /*
     * 导入
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/zms/archive/workPlan/uploadForCont", p, c),
  },
  workPlan_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/workPlan/list", p, c),
  },
  workPlan_listUnFinishClassRoom: {
    /*
     * 未完成工作计划的班级
     * timeType 类型：本周，下周 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/archive/workPlan/listUnFinishClassRoom", p, c),
  },
  workPlan_listUnFinishClassRoomForCont: {
    /*
     * 未完成工作计划的班级
     * timeType 类型：本周，下周 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/archive/workPlan/listUnFinishClassRoomForCont", p, c),
  },
  workPlan_listForCont: {
    /*
     * 列表(职教学校平台)
     */
    get: (p, c) => $.get("/api/zms/archive/workPlan/listForCont", p, c),
  },
  workPlan_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/workPlan/export", p, c),
  },
  workPlan_exportForCont: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/workPlan/exportForCont", p, c),
  },
  workPlan_countUnFinishClassRoom: {
    /*
     * 未完成工作计划的班级数量
     * timeType 类型：本周，下周 (string query required)
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     */
    get: (p, c) =>
      $.get("/api/zms/archive/workPlan/countUnFinishClassRoom", p, c),
  },
  workPlan_countUnFinishClassRoomForFont: {
    /*
     * 未完成工作计划的班级数量
     * timeType 类型：本周，下周 (string query required)
     * headerTeacherId 班主任id (integer query )
     */
    get: (p, c) =>
      $.get("/api/zms/archive/workPlan/countUnFinishClassRoomForFont", p, c),
  },

  /**
   * 职教与讲师交流记录
   */
  teacherComm: {
    /*
     * 添加
     * teacherComm  ( query required)
     */
    post: (p, c) => $.post("/api/zms/archive/teacherComm", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/teacherComm", p, c),
  },
  teacherComm_upload: {
    /*
     * 导入
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/zms/archive/teacherComm/upload", p, c),
  },
  teacherComm_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/teacherComm/list", p, c),
  },
  teacherComm_listUnfinish: {
    /*
     * 本月未沟通老师列表
     */
    get: (p, c) => $.get("/api/zms/archive/teacherComm/listUnfinish", p, c),
  },
  teacherComm_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/teacherComm/export", p, c),
  },
  teacherComm_countUnfinish: {
    /*
     * 本月未沟通老师数量
     */
    get: (p, c) => $.get("/api/zms/archive/teacherComm/countUnfinish", p, c),
  },

  /**
   * 班主任和讲师沟通名单
   */
  teacherCommRoster: {
    /*
     * 添加
     * roster  ( query required)
     */
    post: (p, c) => $.post("/api/zms/archive/teacherCommRoster", p, c),

    /*
     * 删除
     * ids ids (array query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/teacherCommRoster", p, c),
  },
  teacherCommRoster_upload: {
    /*
     * 导入
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/zms/archive/teacherCommRoster/upload", p, c),
  },
  teacherCommRoster_copy: {
    /*
     * 复制
     * fromTime 源时间 (string query required)
     * toTime 目标时间 (string query required)
     * siteId 学校id (integer query )
     */
    post: (p, c) => $.post("/api/zms/archive/teacherCommRoster/copy", p, c),
  },
  teacherCommRoster_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/teacherCommRoster/list", p, c),
  },
  teacherCommRoster_listTeacherByHeaderTeacher: {
    /*
     * 老师列表（班主任）
     * commTime 沟通时间 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/archive/teacherCommRoster/listTeacherByHeaderTeacher",
        p,
        c
      ),
  },
  teacherCommRoster_listCourseByHeaderTeacher: {
    /*
     * 课程列表（班主任）
     * commTime 沟通时间 (string query required)
     * teacherName 老师姓名 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/archive/teacherCommRoster/listCourseByHeaderTeacher",
        p,
        c
      ),
  },
  teacherCommRoster_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/teacherCommRoster/export", p, c),
  },

  /**
   * 职教听课记录
   */
  lectures: {
    /*
     * 添加
     * lectures  ( query required)
     */
    post: (p, c) => $.post("/api/zms/archive/lectures", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/lectures", p, c),
  },
  lectures_upload: {
    /*
     * 导入
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/zms/archive/lectures/upload", p, c),
  },
  lectures_unfinishCount: {
    /*
     * 未完成数量
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     */
    get: (p, c) => $.get("/api/zms/archive/lectures/unfinishCount", p, c),
  },
  lectures_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/lectures/list", p, c),
  },
  lectures_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/lectures/export", p, c),
  },

  /**
   * 职教奖惩
   */
  incentive: {
    /*
     * 添加
     * incentive  ( query required)
     */
    post: (p, c) => $.post("/api/zms/archive/incentive", p, c),
  },
  incentive_listBySchoolRollId: {
    /*
     * 根据合同id查询
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) => $.get("/api/zms/archive/incentive/listBySchoolRollId", p, c),
  },

  /**
   * 职教班会
   */
  classMeeting: {
    /*
     * 添加
     * meeting  ( query required)
     */
    post: (p, c) => $.post("/api/zms/archive/classMeeting", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/classMeeting", p, c),
  },
  classMeeting_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/classMeeting/list", p, c),
  },
  classMeeting_listUnFinishClassRoom: {
    /*
     * 未完成班会的班级
     * type 类型：日常班会、班委会议、主题班会 (string query )
     */
    get: (p, c) =>
      $.get("/api/zms/archive/classMeeting/listUnFinishClassRoom", p, c),
  },
  classMeeting_listUnFinishClassRoomForCont: {
    /*
     * 未完成班会的班级
     * type 类型：日常班会、班委会议、主题班会 (string query )
     */
    get: (p, c) =>
      $.get("/api/zms/archive/classMeeting/listUnFinishClassRoomForCont", p, c),
  },
  classMeeting_listSimpleByClassRoomId: {
    /*
     * 根据班级id获取班会列表
     * classRoomId 班级id (integer query required)
     * type 类型 (string query required)
     * timeType 时间类型 (string query )
     * startTime 开始时间 (string query )
     * endTime 结束时间 (string query )
     */
    get: (p, c) =>
      $.get("/api/zms/archive/classMeeting/listSimpleByClassRoomId", p, c),
  },
  classMeeting_listCont: {
    /*
     * 列表(职教学校平台)
     */
    get: (p, c) => $.get("/api/zms/archive/classMeeting/listCont", p, c),
  },
  classMeeting_countUnFinishClassRoom: {
    /*
     * 未完成班会的班级数量
     * type 类型：日常班会、班委会议、主题班会 (string query )
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     */
    get: (p, c) =>
      $.get("/api/zms/archive/classMeeting/countUnFinishClassRoom", p, c),
  },
  classMeeting_countUnFinishClassRoomForCont: {
    /*
     * 未完成班会的班级数量
     * type 类型：日常班会、班委会议、主题班会 (string query )
     * headerTeacherId 班主任id (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/zms/archive/classMeeting/countUnFinishClassRoomForCont",
        p,
        c
      ),
  },

  /**
   * 职教寝室
   */
  bedroom: {
    /*
     * 添加
     * bedroom  ( query required)
     */
    post: (p, c) => $.post("/api/zms/archive/bedroom", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/bedroom", p, c),
  },
  bedroom_uploadHead: {
    /*
     * 导入修改寝室长
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/zms/archive/bedroom/uploadHead", p, c),
  },
  bedroom_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/bedroom/list", p, c),
  },
  bedroom_listSimple: {
    /*
     * 简易列表
     * siteId 学校id (integer query required)
     * halls 宿舍楼 (string query required)
     */
    get: (p, c) => $.get("/api/zms/archive/bedroom/listSimple", p, c),
  },
  bedroom_listHalls: {
    /*
     * 楼栋列表
     * siteId 学校id (integer query required)
     */
    get: (p, c) => $.get("/api/zms/archive/bedroom/listHalls", p, c),
  },
  bedroom_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/archive/bedroom/export", p, c),
  },

  /**
   * 档案模板
   */
  archiveTemplate: {
    /*
     * 添加
     * template  ( query required)
     */
    post: (p, c) => $.post("/api/zms/archive/archiveTemplate", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/archive/archiveTemplate", p, c),
  },
  archiveTemplate_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/archiveTemplate/list", p, c),
  },
  archiveTemplate_listForCont: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/archive/archiveTemplate/listForCont", p, c),
  },
  archiveTemplate_exportArchive: {
    /*
     * 档案导出
     * name 模板名称 (string query required)
     * siteId 学校id (integer query )
     * classRoomId 班级id (integer query )
     * schoolRollId 合同id (integer query )
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     * term 学期 (integer query )
     */
    get: (p, c) =>
      $.get("/api/zms/archive/archiveTemplate/exportArchive", p, c),
  },
  archiveTemplate_exportArchiveForCont: {
    /*
     * 档案导出(职教学校平台)
     * name 模板名称 (string query required)
     * classRoomId 班级id (integer query )
     * schoolRollId 合同id (integer query )
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     * term 学期 (integer query )
     */
    get: (p, c) =>
      $.get("/api/zms/archive/archiveTemplate/exportArchiveForCont", p, c),
  },
};
